import IPagination from '@interfaces/IPagination';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import BaseService, { RequestInterface } from './Base';
import { AwsConfig as AwsConstants } from './Constants';


export default class TicketEventLIServiceEhss extends BaseService {
  constructor() {
    super(AwsConstants.API_LI, 'ticket-event');
  }

  async paging(query: BasePaginationQuery, idProcess?: string, fields?: string[]): Promise<IPagination<any>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.status) {
      params.queryStringParameters['status'] = query.status;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.from) {
      params.queryStringParameters['from'] = query.offset;
    }
    if (query.to) {
      params.queryStringParameters['to'] = query.offset;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search; // by name
    }
    // if (query.process) {
    //   params.queryStringParameters['process'] = query.process; // by name
    // }
    if (query.auditorId) {
      params.queryStringParameters['auditorId'] = query.auditorId; // by name
    }
    if (query.owner) {
      params.queryStringParameters['owner'] = query.owner; // by name
    }
    if (query.process) {
      params.queryStringParameters['process'] = query.process; // by name
    }
    const res = await super.get<IPagination<any>>('process', params);

    return res;
  }

  async pagingByRole(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.status) {
      params.queryStringParameters['status'] = query.status;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.from) {
      params.queryStringParameters['from'] = query.offset;
    }
    if (query.to) {
      params.queryStringParameters['to'] = query.offset;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search; // by name
    }
    if (query.process) {
      params.queryStringParameters['process'] = query.process; // by name
    }
    if (query.owner) {
      params.queryStringParameters['owner'] = query.owner; // by name
    }

    const res = await super.get<IPagination<any>>('me/process', params);

    return res;
  }

  async pagingTicket(idProcess: string, query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.status) {
      params.queryStringParameters['status'] = query.status;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.from) {
      params.queryStringParameters['from'] = query.offset;
    }
    if (query.to) {
      params.queryStringParameters['to'] = query.offset;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search; // by name
    }
    if (query.process) {
      params.queryStringParameters['process'] = query.process; // by name
    }
    if (query.auditorId) {
      params.queryStringParameters['auditor'] = query.auditorId; // by name
    }
    if (query.auditedId) {
      params.queryStringParameters['audited'] = query.auditedId; // by name
    }
    const res = await super.get<IPagination<any>>(`process/${idProcess}`, params);
    return res;
  }

  async getGLOBAL(id: string, asc: boolean, fields?: string[]): Promise<any> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (asc) {
      params.queryStringParameters['asc'] = asc;
    }
    try {
      const res = await super.get<any>(`ticket/${id}`, params);
      return res;
    } catch (error) {
      return { fields: [] };
    }
  }

  async exportProcess(idProcess: string, query: BasePaginationQuery, fields?: string[]): Promise<any> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.from) {
      params.queryStringParameters['from'] = query.from; // by name
    }
    if (query.to) {
      params.queryStringParameters['to'] = query.to; // by name
    }
    if (query.status) {
      params.queryStringParameters['status'] = query.status; // by name
    }
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    params.queryStringParameters['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone.toString()
    try {
      const res = await super.export<any>(`process/${idProcess}/export`, params);
      return res;
    } catch (error) {
      return { fields: [] };
    }
  }

  async ownerAdd(id: string, userId: string): Promise<void> {
    await super.patch<void>(`${id}/owner/${userId}`);
  }

  async ownerRemove(id: string, userId: string): Promise<void> {
    await super.delete<void>(`${id}/owner/${userId}`);
  }

}